import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class InductionService {

  constructor(private http: HttpClient) { }

  getInductionsUsers(): Observable<any> {
    
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "induction/").subscribe((res: any) => {
        console.log(res)
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  download(id){
    return new Observable((observer) => {
      this.http.get(config.baseApiUrl + "induction/" + id).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }


}
